export const CopyTextToClipboard = ({ text }: { text: string }) => {
  return navigator.clipboard.writeText(text);
};
